import { AppBar, Dialog, Toolbar, WithStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { UpwardTransition } from 'src/utils';
import { CurriculumTypes } from '../components/CurriculumCard';
import { ElearningTypes } from '../components/ELearningCard';

import * as Actions from '../actions/imstat';
import { IUserAttr } from '../actions/session';
import ImstatCurriculumCard from '../components/ImstatCurriculumCard';
import ImstatDistanceLearningCard from '../components/ImstatDistanceLearningCard';
import ImstatELearningCard from '../components/ImstatELearningCard';
import ImstatGroupTrainingCard, {
	GroupTrainingTypes,
} from '../components/ImstatGroupTrainingCard';
import TrainingProgress from '../components/TrainingProgress';
import CardIcon from '../icons/ImstatCard';
import TableIcon from '../icons/ImstatTable';
import { IRootState } from '../reducers';
import { IImstate } from '../reducers/imstat';
import i18n from '../resources/i18n';
import ScenariFactory from '../scenario/ImstatScenarioFactory';
import { isValid, MasterItemCode } from '../utils/MasterData';
import { isMobile } from '../utils/MobileCheck';
import ImstatCurriculumTable, {
	CurriculumTypes as TableCurriculumTypes,
} from './ImstatCurriculumTable';
import ImstatDistanceLearningTable, {
	DistanceLearningTypes,
} from './ImstatDistanceLearningTable';
import ImstatELearningTable from './ImstatELearningTable';
import { ELearningTableTypes } from './ImstatELearningTable';
import ImstatGroupTrainingTable, {
	GroupTrainingTypes as TableGroupTrainingTypes,
} from './ImstatGroupTrainingTable';

// shortcut
import ShowTypes = Actions.ImstatShowTypes;
import {
	IApprovalStayMealData,
	setApprovalStayMealList,
} from 'src/actions/search';
import ApplicationStatus from './ApplicationStatus';
import CareerDetail from './CareerDetail';
import CurriculumDetail from './CurriculumDetail';
export enum TabRow {
	E_LEARNING,
	GROUP_TRAINING,
	DISTANCE_LEARNING,
	CURRICULUM,
}

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		caption: {
			marginTop: -14,
		},
		careerDialog: {
			width: '80%',
		},
		flex: {
			flex: 1,
		},
		paper: {
			marginBottom: theme.spacing(1),
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
			marginTop: theme.spacing(2),
			paddingBottom: theme.spacing(2),
			paddingLeft: theme.spacing(1),
			paddingRight: theme.spacing(1),
			paddingTop: theme.spacing(0),
		},
	});

/**
 * 実施中受講・実績状況
 */
class ImstatOnGoing extends React.Component<IProps> {
	public constructor(props: IProps) {
		super(props);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.fetchDefaultDisplayFormatAt && !isMobile()) {
			this.props.fetchDefaultDisplaySetting(this.props.token);
		}
		if (!this.props.onGoingELearning.setDataAt) {
			this.props.fetchOnGoingELearning(
				this.props.token,
				this.props.userAttr,
				this.props.onlyQualificationDispalyFlg
			);
		}
		const careerTypeControl = isValid(MasterItemCode.CAREER_TYPE_CONTROL);
		if (careerTypeControl && !this.props.onGoingGroupTraining.setDataAt) {
			this.props.fetchOnGoingGroupTraining(
				this.props.token,
				this.props.userAttr,
				this.props.onlyQualificationDispalyFlg
			);
		}
		if (
			careerTypeControl &&
			!this.props.onGoingDistanceLearning.setDataAt
		) {
			this.props.fetchOnGoingDistanceLearning(
				this.props.token,
				this.props.userAttr,
				this.props.onlyQualificationDispalyFlg
			);
		}
		if (!this.props.onGoingCurriculum.setDataAt) {
			this.props.fetchOnGoingCurriculum(
				this.props.token,
				this.props.userAttr,
				this.props.onlyQualificationDispalyFlg
			);
		}
		this.props.setApprovalStayMealList([]);
	}

	public componentWillUnmount() {
		this.props.clearImstatParams();
	}

	public componentWillUpdate(nextProps: IProps) {
		if (this.props.onGoingELearning !== nextProps.onGoingELearning) {
			return true;
		}
		if (
			this.props.onGoingGroupTraining !== nextProps.onGoingGroupTraining
		) {
			return true;
		}
		if (
			this.props.onGoingDistanceLearning !==
			nextProps.onGoingDistanceLearning
		) {
			return true;
		}
		if (this.props.onGoingCurriculum !== nextProps.onGoingCurriculum) {
			return true;
		}
		return false;
	}

	public render() {
		const {
			classes,
			onGoingELearning,
			onGoingGroupTraining,
			onGoingCurriculum,
			onGoingDistanceLearning,
		} = this.props;

		return (
			<>
				<Paper className={classes.paper} id="e-learning">
					<Grid container={true} alignItems="flex-end">
						<Grid item={true} className={classes.flex}>
							<Typography variant="h6">
								{i18n.t('ImstatOnGoing_0001')}
							</Typography>
						</Grid>
						{!isMobile() && (
							<>
								<Grid item={true}>
									<IconButton
										onClick={this.handleClickCard(
											TabRow.E_LEARNING
										)}
										color="primary"
										disabled={
											this.props.onGoingELearning
												.showType ===
											ShowTypes.IMSTAT_SHOW_TYPE_CARD
										}
									>
										<CardIcon />
									</IconButton>
									<Typography
										variant="caption"
										align="center"
										className={classes.caption}
										display="block"
									>
										{i18n.t('ImstatOnGoing_0002')}
									</Typography>
								</Grid>
								<Grid item={true}>
									<IconButton
										onClick={this.handleClickTable(
											TabRow.E_LEARNING
										)}
										color="primary"
										disabled={
											this.props.onGoingELearning
												.showType ===
											ShowTypes.IMSTAT_SHOW_TYPE_TABLE
										}
									>
										<TableIcon />
									</IconButton>
									<Typography
										variant="caption"
										align="center"
										className={classes.caption}
										display="block"
									>
										{i18n.t('ImstatOnGoing_0003')}
									</Typography>
								</Grid>
							</>
						)}
						<Grid item={true}>
							<IconButton
								onClick={this.reloadOnGoing(TabRow.E_LEARNING)}
								color="primary"
							>
								<RefreshIcon />
							</IconButton>
							<Typography
								variant="caption"
								align="center"
								className={classes.caption}
								display="block"
							>
								{i18n.t('ImstatOnGoing_0004')}
							</Typography>
						</Grid>
					</Grid>
					<ELearning eLearning={onGoingELearning} />
				</Paper>
				{isValid(MasterItemCode.CAREER_TYPE_CONTROL) && (
					<Paper className={classes.paper} id="group-training">
						<Grid container={true} alignItems="flex-end">
							<Grid item={true} className={classes.flex}>
								<Typography variant="h6">
									{i18n.t('ImstatOnGoing_0005')}
								</Typography>
							</Grid>
							{!isMobile() && (
								<>
									<Grid item={true}>
										<IconButton
											onClick={this.handleClickCard(
												TabRow.GROUP_TRAINING
											)}
											color="primary"
											disabled={
												this.props.onGoingGroupTraining
													.showType ===
												ShowTypes.IMSTAT_SHOW_TYPE_CARD
											}
										>
											<CardIcon />
										</IconButton>
										<Typography
											variant="caption"
											align="center"
											className={classes.caption}
											display="block"
										>
											{i18n.t('ImstatOnGoing_0006')}
										</Typography>
									</Grid>
									<Grid item={true}>
										<IconButton
											onClick={this.handleClickTable(
												TabRow.GROUP_TRAINING
											)}
											color="primary"
											disabled={
												this.props.onGoingGroupTraining
													.showType ===
												ShowTypes.IMSTAT_SHOW_TYPE_TABLE
											}
										>
											<TableIcon />
										</IconButton>
										<Typography
											variant="caption"
											align="center"
											className={classes.caption}
											display="block"
										>
											{i18n.t('ImstatOnGoing_0007')}
										</Typography>
									</Grid>
								</>
							)}
							<Grid item={true}>
								<IconButton
									onClick={this.reloadOnGoing(
										TabRow.GROUP_TRAINING
									)}
									color="primary"
								>
									<RefreshIcon />
								</IconButton>
								<Typography
									variant="caption"
									align="center"
									className={classes.caption}
									display="block"
								>
									{i18n.t('ImstatOnGoing_0008')}
								</Typography>
							</Grid>
						</Grid>
						<GroupTraining groupTraining={onGoingGroupTraining} />
					</Paper>
				)}
				{isValid(MasterItemCode.CAREER_TYPE_CONTROL) && (
					<Paper className={classes.paper} id="distance-learning">
						<Grid container={true} alignItems="flex-end">
							<Grid item={true} className={classes.flex}>
								<Typography variant="h6">
									{i18n.t('ImstatOnGoing_0009')}
								</Typography>
							</Grid>
							{!isMobile() && (
								<>
									<Grid item={true}>
										<IconButton
											onClick={this.handleClickCard(
												TabRow.DISTANCE_LEARNING
											)}
											color="primary"
											disabled={
												this.props
													.onGoingDistanceLearning
													.showType ===
												ShowTypes.IMSTAT_SHOW_TYPE_CARD
											}
										>
											<CardIcon />
										</IconButton>
										<Typography
											variant="caption"
											align="center"
											className={classes.caption}
											display="block"
										>
											{i18n.t('ImstatOnGoing_0010')}
										</Typography>
									</Grid>
									<Grid item={true}>
										<IconButton
											onClick={this.handleClickTable(
												TabRow.DISTANCE_LEARNING
											)}
											color="primary"
											disabled={
												this.props
													.onGoingDistanceLearning
													.showType ===
												ShowTypes.IMSTAT_SHOW_TYPE_TABLE
											}
										>
											<TableIcon />
										</IconButton>
										<Typography
											variant="caption"
											align="center"
											className={classes.caption}
											display="block"
										>
											{i18n.t('ImstatOnGoing_0011')}
										</Typography>
									</Grid>
								</>
							)}
							<Grid item={true}>
								<IconButton
									onClick={this.reloadOnGoing(
										TabRow.DISTANCE_LEARNING
									)}
									color="primary"
								>
									<RefreshIcon />
								</IconButton>
								<Typography
									variant="caption"
									align="center"
									className={classes.caption}
									display="block"
								>
									{i18n.t('ImstatOnGoing_0012')}
								</Typography>
							</Grid>
						</Grid>
						<DistanceLearning
							distanceLearning={onGoingDistanceLearning}
						/>
					</Paper>
				)}
				<Paper className={classes.paper} id="curriculum">
					<Grid container={true} alignItems="flex-end">
						<Grid item={true} className={classes.flex}>
							<Typography variant="h6">
								{i18n.t('ImstatOnGoing_0013')}
							</Typography>
						</Grid>
						{!isMobile() && (
							<>
								<Grid item={true}>
									<IconButton
										onClick={this.handleClickCard(
											TabRow.CURRICULUM
										)}
										color="primary"
										disabled={
											this.props.onGoingCurriculum
												.showType ===
											ShowTypes.IMSTAT_SHOW_TYPE_CARD
										}
									>
										<CardIcon />
									</IconButton>
									<Typography
										variant="caption"
										align="center"
										className={classes.caption}
										display="block"
									>
										{i18n.t('ImstatOnGoing_0014')}
									</Typography>
								</Grid>
								<Grid item={true}>
									<IconButton
										onClick={this.handleClickTable(
											TabRow.CURRICULUM
										)}
										color="primary"
										disabled={
											this.props.onGoingCurriculum
												.showType ===
											ShowTypes.IMSTAT_SHOW_TYPE_TABLE
										}
									>
										<TableIcon />
									</IconButton>
									<Typography
										variant="caption"
										align="center"
										className={classes.caption}
										display="block"
									>
										{i18n.t('ImstatOnGoing_0015')}
									</Typography>
								</Grid>
							</>
						)}
						<Grid item={true}>
							<IconButton
								onClick={this.reloadOnGoing(TabRow.CURRICULUM)}
								color="primary"
							>
								<RefreshIcon />
							</IconButton>
							<Typography
								variant="caption"
								align="center"
								className={classes.caption}
								display="block"
							>
								{i18n.t('ImstatOnGoing_0016')}
							</Typography>
						</Grid>
					</Grid>
					<Curriculum curriculum={onGoingCurriculum} />
				</Paper>
				<TrainingProgress
					data={this.props.trainingProgress}
					onClose={this.handleCloseTrainingProgress}
				/>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={
						this.props.careerDetailDialog.setOpenCareerDetailDialog
					}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('ImstatOnGoing_0017')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CareerDetail
						careerID={this.props.careerDetailDialog.careerID}
					/>
				</Dialog>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={
						this.props.careerDetailDialog
							.setOpenCurriculumDetailDialog
					}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('ImstatOnGoing_0018')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CurriculumDetail
						curriculumId={this.props.careerDetailDialog.careerID}
					/>
				</Dialog>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={
						this.props.careerDetailDialog.setApplicationStatusDialog
					}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('ImstatOnGoing_0019')}
							</Typography>
						</Toolbar>
					</AppBar>
					<ApplicationStatus
						careerID={this.props.careerDetailDialog.careerID}
						classID={this.props.careerDetailDialog.classID}
						apllType={this.props.careerDetailDialog.apllType}
						curriculumFlg={
							this.props.careerDetailDialog.curriculumFlg
						}
					/>
				</Dialog>
			</>
		);
	}

	/**
	 * 表示情報取得
	 */
	protected reloadOnGoing = (tableType: number) => () => {
		switch (tableType) {
			case TabRow.E_LEARNING:
				this.props.fetchOnGoingELearning(
					this.props.token,
					this.props.userAttr,
					this.props.onlyQualificationDispalyFlg
				);
				break;
			case TabRow.GROUP_TRAINING:
				this.props.fetchOnGoingGroupTraining(
					this.props.token,
					this.props.userAttr,
					this.props.onlyQualificationDispalyFlg
				);
				break;
			case TabRow.DISTANCE_LEARNING:
				this.props.fetchOnGoingDistanceLearning(
					this.props.token,
					this.props.userAttr,
					this.props.onlyQualificationDispalyFlg
				);
				break;
			case TabRow.CURRICULUM:
				this.props.fetchOnGoingCurriculum(
					this.props.token,
					this.props.userAttr,
					this.props.onlyQualificationDispalyFlg
				);
				break;
			default:
		}
	};

	/**
	 * カード表示ハンドラ
	 */
	protected handleClickCard = (tableType: number) => () => {
		switch (tableType) {
			case TabRow.E_LEARNING:
				this.props.setOnGoingELearningShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_CARD
				);
				break;
			case TabRow.GROUP_TRAINING:
				this.props.setOnGoingGroupTrainingShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_CARD
				);
				break;
			case TabRow.DISTANCE_LEARNING:
				this.props.setOnGoingDistanceLearningShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_CARD
				);
				break;
			case TabRow.CURRICULUM:
				this.props.setOnGoingCurriculumShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_CARD
				);
				break;
			default:
		}
	};

	/**
	 * テーブル表示ハンドラ
	 */
	protected handleClickTable = (tableType: number) => () => {
		switch (tableType) {
			case TabRow.E_LEARNING:
				this.props.setOnGoingELearningShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_TABLE
				);
				break;
			case TabRow.GROUP_TRAINING:
				this.props.setOnGoingGroupTrainingShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_TABLE
				);
				break;
			case TabRow.DISTANCE_LEARNING:
				this.props.setOnGoingDistanceLearningShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_TABLE
				);
				break;
			case TabRow.CURRICULUM:
				this.props.setOnGoingCurriculumShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_TABLE
				);
				break;
			default:
		}
	};

	/**
	 * 読み込み中インジケータクローズハンドラ
	 */
	protected handleCloseTrainingProgress = (event: React.ChangeEvent<{}>) => {
		this.props.clearTrainingProgress();
	};

	protected handlecloseDetailDialog = () => {
		const careerDetailDialog: Actions.ICareerDetailDialog = {
			apllType: '',
			careerID: '',
			classID: '',
			curriculumFlg: '0',
			setApplicationStatusDialog: false,
			setOpenCareerDetailDialog: false,
			setOpenCurriculumDetailDialog: false,
		};
		this.props.setCareerDetailDialog(careerDetailDialog);
	};
}

interface IELearningProps {
	eLearning: IImstate<Actions.IOnGoingELearning>;
}

const ELearning: React.FC<IELearningProps> = props => {
	const style = {
		minHeight: 10,
		width: '100%',
	};
	switch (props.eLearning.showType) {
		case ShowTypes.IMSTAT_SHOW_TYPE_TABLE:
			// eラーニングのテーブル表示
			return (
				<div style={style}>
					<ImstatELearningTable
						data={props.eLearning.data}
						selectedColumns={props.eLearning.selectedColumns}
						type={ELearningTableTypes.ONGOING}
					/>
				</div>
			);
		case ShowTypes.IMSTAT_SHOW_TYPE_CARD:
			// eラーニングのカード表示
			return (
				<div style={style}>
					<ImstatELearningCard
						data={props.eLearning.data}
						type={ElearningTypes.ONGOING}
					/>
				</div>
			);
		default:
			// eラーニングの初期表示
			return <></>;
	}
};

interface IGroupTrainingProps {
	groupTraining: IImstate<Actions.IOnGoingGroupTraining>;
}

const GroupTraining: React.FC<IGroupTrainingProps> = props => {
	const style = {
		minHeight: 10,
		width: '100%',
	};

	switch (props.groupTraining.showType) {
		case ShowTypes.IMSTAT_SHOW_TYPE_TABLE:
			// カリキュラムのテーブル表示
			return (
				<div style={style}>
					<ImstatGroupTrainingTable
						data={props.groupTraining.data}
						selectedColumns={props.groupTraining.selectedColumns}
						type={TableGroupTrainingTypes.ONGOING}
					/>
				</div>
			);
		case ShowTypes.IMSTAT_SHOW_TYPE_CARD:
			// カリキュラムのカード表示
			return (
				<div style={style}>
					<ImstatGroupTrainingCard
						data={props.groupTraining.data}
						type={GroupTrainingTypes.ONGOING}
					/>
				</div>
			);
		default:
			// カリキュラムの初期表示
			return <></>;
	}
};

interface IDistanceLearningProps {
	distanceLearning: IImstate<Actions.IOnGoingDistanceLearning>;
}

const DistanceLearning: React.FC<IDistanceLearningProps> = props => {
	const style = {
		minHeight: 10,
		width: '100%',
	};

	switch (props.distanceLearning.showType) {
		case ShowTypes.IMSTAT_SHOW_TYPE_TABLE:
			// 通信教育のテーブル表示
			return (
				<div style={style}>
					<ImstatDistanceLearningTable
						data={props.distanceLearning.data}
						selectedColumns={props.distanceLearning.selectedColumns}
						type={DistanceLearningTypes.ONGOING}
					/>
				</div>
			);
		case ShowTypes.IMSTAT_SHOW_TYPE_CARD:
			// 通信教育のカード表示
			return (
				<div style={style}>
					<ImstatDistanceLearningCard
						data={props.distanceLearning.data}
						type={DistanceLearningTypes.ONGOING}
					/>
				</div>
			);
		default:
			// 通信教育の初期表示
			return <></>;
	}
};

interface ICurriculumProps {
	curriculum: IImstate<Actions.ICurriculum>;
}

const Curriculum: React.FC<ICurriculumProps> = props => {
	const style = {
		minHeight: 10,
		width: '100%',
	};

	switch (props.curriculum.showType) {
		case ShowTypes.IMSTAT_SHOW_TYPE_TABLE:
			// カリキュラムのテーブル表示
			return (
				<div style={style}>
					<ImstatCurriculumTable
						data={props.curriculum.data}
						selectedColumns={props.curriculum.selectedColumns}
						type={TableCurriculumTypes.ONGOING}
					/>
				</div>
			);
		case ShowTypes.IMSTAT_SHOW_TYPE_CARD:
			// カリキュラムのカード表示
			return (
				<div style={style}>
					<ImstatCurriculumCard
						data={props.curriculum.data}
						type={CurriculumTypes.ONGOING}
					/>
				</div>
			);
		default:
			// カリキュラムの初期表示
			return <></>;
	}
};

const mapStateToProps = (state: IRootState) => ({
	careerDetailDialog: state.imstat.careerDetailDialog,
	fetchDefaultDisplayFormatAt: state.imstat.fetchDefaultDisplayFormatAt,
	onGoingCurriculum: state.imstat.onGoingCurriculum,
	onGoingDistanceLearning: state.imstat.onGoingDistanceLearning,
	onGoingELearning: state.imstat.onGoingELearning,
	onGoingGroupTraining: state.imstat.onGoingGroupTraining,
	token: state.session.token,
	trainingProgress: state.imstat.trainingProgress,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	clearImstatParams: () => dispatch(Actions.clearImstat()),
	clearTrainingProgress: () =>
		dispatch(Actions.setTrainingProgress({ trainingProgress: 'none' })),
	fetchDefaultDisplaySetting: (token: string) => {
		const s = ScenariFactory.createFetchDefaultDisplaySetting(
			dispatch,
			token
		);
		s.run({});
	},
	fetchOnGoingCurriculum: (
		token: string,
		arg: IUserAttr,
		onlyQualificationDispalyFlg: string
	) => {
		const s = ScenariFactory.createFetchOnGoingCurriculum(
			dispatch,
			token,
			onlyQualificationDispalyFlg
		);
		s.run(arg);
	},
	fetchOnGoingDistanceLearning: (
		token: string,
		arg: IUserAttr,
		onlyQualificationDispalyFlg: string
	) => {
		const s = ScenariFactory.createFetchOnGoingDistanceLearning(
			dispatch,
			token,
			onlyQualificationDispalyFlg
		);
		s.run(arg);
	},
	fetchOnGoingELearning: (
		token: string,
		arg: IUserAttr,
		onlyQualificationDispalyFlg: string
	) => {
		const s = ScenariFactory.createFetchOnGoingELearning(
			dispatch,
			token,
			onlyQualificationDispalyFlg
		);
		s.run(arg);
	},
	fetchOnGoingGroupTraining: (
		token: string,
		arg: IUserAttr,
		onlyQualificationDispalyFlg: string
	) => {
		const s = ScenariFactory.createFetchOnGoingGroupTraining(
			dispatch,
			token,
			onlyQualificationDispalyFlg
		);
		s.run(arg);
	},
	setOnGoingCurriculumShowType: (type: Actions.ImstatShowTypes) =>
		dispatch(
			Actions.setImstatOnGoingCurriculumShowType({ showType: type })
		),
	setOnGoingDistanceLearningShowType: (type: Actions.ImstatShowTypes) =>
		dispatch(
			Actions.setImstatOnGoingDistanceLearningShowType({ showType: type })
		),
	setOnGoingELearningShowType: (type: Actions.ImstatShowTypes) =>
		dispatch(Actions.setImstatOnGoingELearningShowType({ showType: type })),
	setOnGoingGroupTrainingShowType: (type: Actions.ImstatShowTypes) =>
		dispatch(
			Actions.setImstatOnGoingGroupTrainingShowType({ showType: type })
		),

	setCareerDetailDialog: (CareerDetailDialog: Actions.ICareerDetailDialog) =>
		dispatch(Actions.setCareerDetailDialog({ CareerDetailDialog })),

	setApprovalStayMealList: (approvalStayMealList: IApprovalStayMealData[]) =>
		dispatch(setApprovalStayMealList({ approvalStayMealList })),
});

// tslint:disable-next-line: no-empty-interface
export interface IImstatOnGoingProps {
	onlyQualificationDispalyFlg: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IImstatOnGoingProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ImstatOnGoing);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/ImstatOnGoing.tsx